import { Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'tyt-copy-box',
  templateUrl: './copy-box.component.html',
  styleUrls: ['./copy-box.component.scss']
})
export class CopyBoxComponent {
  private snackBar = inject(MatSnackBar);

  @Input() label: string;
  @Input() value: string;

  @ViewChild('input') input: ElementRef<HTMLInputElement>;

  select() {
    this.input.nativeElement.select();
  }

  copy() {
    this.select();
    document.execCommand('copy');
    this.snackBar.open("Copied to clipboard.", undefined, { duration: 2000 });
  }
}
